import { render, staticRenderFns } from "./Educations.vue?vue&type=template&id=3c554643&scoped=true"
import script from "./Educations.vue?vue&type=script&lang=js"
export * from "./Educations.vue?vue&type=script&lang=js"
import style0 from "./Educations.vue?vue&type=style&index=0&id=3c554643&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c554643",
  null
  
)

export default component.exports